import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ZoomInMapIcon(props: IconProps) {
    return <Icon {...props} iconKey={"zoom_in_map"}/>
}
